import { ChangeDetectionStrategy, Component, Injector, Input, ViewChild } from '@angular/core';
import { AbstractValueAccessor, MakeProvider } from '../abstract-value-accessor';
import { DatePickerComponent } from '../date-picker/date-picker.component';

export interface DateRange {
  fromDate: string;
  untilDate: string;
}

@Component({
  selector: 'app-date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss'],
  providers: [MakeProvider(DateRangeComponent)],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateRangeComponent extends AbstractValueAccessor {
  @ViewChild('fromDate', { static: true })
  fromDateDatePicker: DatePickerComponent;

  @ViewChild('untilDate', { static: true })
  untilDateDatePicker: DatePickerComponent;

  @Input()
  validateOnDirty: boolean;

  @Input()
  required: boolean;

  @Input()
  fromDatePlaceholder: string;

  @Input()
  untilDatePlaceholder: string;

  @Input()
  columnName: string;

  @Input()
  label: string;

  @Input()
  labelWithColon = false;

  // A value sets a minimum date possible limit to select in 'From' date picker
  @Input()
  minDate: Date;

  // A value sets a maximum date possible limit to select in 'From' date picker
  @Input()
  maxDate: Date;

  // Sets limit for maximum selected date for 'Until' date picker
  // If not provided, the limit is not set (Possibility to select until infinity date)
  @Input()
  maxDateLimit?: Date;

  constructor(injector: Injector) {
    super(injector);
  }

  dateChanged(): void {
    const fromDate = this.fromDateDatePicker?.value;
    const untilDate = this.untilDateDatePicker?.value;

    if (fromDate && untilDate) {
      if (new Date(fromDate) > new Date(untilDate)) {
        this.untilDateDatePicker.value = null;
        this.value = null;
      } else if (this.untilDateDatePicker.value) {
        const untilDate = this.untilDateDatePicker.value;
        this.value = {
          fromDate,
          untilDate,
        };
      }
    }
  }

  writeValue(dateRange: DateRange): void {
    if (dateRange) {
      const fromDate = dateRange.fromDate;
      const untilDate = dateRange.untilDate;

      if (fromDate && this.fromDateDatePicker) {
        this.fromDateDatePicker.value = fromDate;
      }

      if (untilDate && this.untilDateDatePicker) {
        this.untilDateDatePicker.value = untilDate;
      }
      super.writeValue(dateRange);
    }
  }
}
